import { StyleSheet, Dimensions } from 'react-native';

const { width: SCREEN_WIDTH } = Dimensions.get('window');

export const createStyles = (primaryColor: string = '#007AFF') =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: '#fff',
    },
    scrollContainer: {
      flexGrow: 1,
    },
    content: {
      flex: 1,
      paddingHorizontal: 24,
      paddingTop: 60,
    },
    // ==================== Logo 区域 ====================
    logoContainer: {
      alignItems: 'center',
      marginBottom: 24,
    },
    logo: {
      width: 80,
      height: 80,
      borderRadius: 16,
    },
    logoPlaceholder: {
      width: 80,
      height: 80,
      borderRadius: 16,
      backgroundColor: primaryColor,
      justifyContent: 'center',
      alignItems: 'center',
    },
    logoIcon: {
      color: '#fff',
    },
    // ==================== 标题区域 ====================
    headerContainer: {
      alignItems: 'center',
      marginBottom: 32,
    },
    appName: {
      fontSize: 24,
      fontWeight: '700',
      color: '#333',
      marginTop: 12,
    },
    title: {
      fontSize: 28,
      fontWeight: '700',
      color: '#333',
      marginBottom: 8,
    },
    subtitle: {
      fontSize: 15,
      color: '#999',
      marginTop: 8,
    },
    // ==================== Tab 栏 ====================
    tabBar: {
      flexDirection: 'row',
      marginBottom: 24,
      borderBottomWidth: 1,
      borderBottomColor: '#eee',
    },
    tabItem: {
      flex: 1,
      paddingVertical: 12,
      alignItems: 'center',
    },
    tabItemActive: {
      borderBottomWidth: 2,
      borderBottomColor: primaryColor,
    },
    tabText: {
      fontSize: 15,
      color: '#999',
    },
    tabTextActive: {
      color: primaryColor,
      fontWeight: '600',
    },
    // ==================== 表单区域 ====================
    formContainer: {
      marginBottom: 20,
    },
    inputWrapper: {
      marginBottom: 16,
    },
    inputRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    codeInput: {
      flex: 1,
    },
    codeButton: {
      marginLeft: 12,
      paddingHorizontal: 16,
      paddingVertical: 12,
      borderRadius: 8,
      backgroundColor: primaryColor,
    },
    codeButtonDisabled: {
      backgroundColor: '#ccc',
    },
    codeButtonText: {
      fontSize: 14,
      color: '#fff',
      fontWeight: '500',
    },
    // ==================== 密码强度 ====================
    passwordStrength: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 8,
      marginBottom: 4,
    },
    strengthBar: {
      flex: 1,
      height: 4,
      backgroundColor: '#eee',
      borderRadius: 2,
      marginRight: 4,
    },
    strengthBarActive: {
      backgroundColor: '#34C759',
    },
    strengthBarMedium: {
      backgroundColor: '#FF9500',
    },
    strengthBarWeak: {
      backgroundColor: '#FF3B30',
    },
    strengthText: {
      fontSize: 12,
      color: '#999',
      marginLeft: 8,
      width: 40,
    },
    // ==================== 忘记密码 ====================
    forgotContainer: {
      alignItems: 'flex-end',
      marginBottom: 24,
    },
    forgotText: {
      fontSize: 14,
      color: primaryColor,
    },
    // ==================== 登录按钮 ====================
    loginButton: {
      height: 50,
      borderRadius: 25,
      backgroundColor: primaryColor,
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 16,
    },
    loginButtonDisabled: {
      backgroundColor: '#ccc',
    },
    loginButtonText: {
      fontSize: 17,
      fontWeight: '600',
      color: '#fff',
    },
    // ==================== 协议区域 ====================
    agreementContainer: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      marginBottom: 24,
      paddingHorizontal: 4,
    },
    checkbox: {
      width: 18,
      height: 18,
      borderRadius: 4,
      borderWidth: 1.5,
      borderColor: '#ddd',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: 8,
      marginTop: 2,
    },
    checkboxChecked: {
      backgroundColor: primaryColor,
      borderColor: primaryColor,
    },
    agreementText: {
      flex: 1,
      fontSize: 12,
      color: '#999',
      lineHeight: 20,
    },
    agreementLink: {
      color: primaryColor,
    },
    // ==================== 分隔线 ====================
    dividerContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginVertical: 24,
    },
    dividerLine: {
      flex: 1,
      height: 1,
      backgroundColor: '#eee',
    },
    dividerText: {
      marginHorizontal: 16,
      fontSize: 13,
      color: '#999',
    },
    // ==================== 第三方登录 ====================
    thirdPartyContainer: {
      marginBottom: 24,
    },
    thirdPartyTitle: {
      fontSize: 13,
      color: '#999',
      textAlign: 'center',
      marginBottom: 20,
    },
    thirdPartyButtons: {
      flexDirection: 'row',
      justifyContent: 'center',
    },
    thirdPartyButton: {
      width: 50,
      height: 50,
      borderRadius: 25,
      backgroundColor: '#f5f5f5',
      justifyContent: 'center',
      alignItems: 'center',
      marginHorizontal: 16,
    },
    thirdPartyIcon: {
      width: 28,
      height: 28,
    },
    // ==================== 底部区域 ====================
    footerContainer: {
      paddingVertical: 24,
      alignItems: 'center',
    },
    footerText: {
      fontSize: 14,
      color: '#999',
    },
    registerLink: {
      color: primaryColor,
      fontWeight: '500',
    },
    // ==================== 一键登录 ====================
    phoneLoginContainer: {
      alignItems: 'center',
      marginBottom: 24,
    },
    phoneLoginButton: {
      width: '100%',
      height: 50,
      borderRadius: 25,
      backgroundColor: primaryColor,
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'row',
    },
    phoneLoginIcon: {
      marginRight: 8,
    },
    phoneLoginText: {
      fontSize: 17,
      fontWeight: '600',
      color: '#fff',
    },
    phoneNumber: {
      fontSize: 14,
      color: '#666',
      marginTop: 12,
    },
    switchLoginType: {
      marginTop: 16,
    },
    switchLoginText: {
      fontSize: 14,
      color: primaryColor,
    },
  });

// 第三方登录图标颜色
export const THIRD_PARTY_COLORS: Record<string, string> = {
  wechat: '#07C160',
  alipay: '#1677FF',
  qq: '#12B7F5',
  weibo: '#E6162D',
};
